import { PriceAttrs } from 'infra/modules/PriceModule/PriceModule.types';
import { ApiHelper } from 'utils/ApiHelper';

const getBaseUrl = (pid) => `/api/v1/projects/${pid}/services/infra/price`;

export const PriceApi = {
    loadPrice(pid) {
        return ApiHelper.rpcCall<PriceAttrs>({
            url: getBaseUrl(pid),
        });
    },
};
